<template> 

    <div v-if="progetto && progetto.ID_PROGETTO" class="row" style="height: auto; margin-bottom: 1rem;">
        <div class="col-3 col-md-3 mb-2">
            <img v-if="progetto.ID_PROGETTO > 0 && progetto.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('PROGETTI',progetto.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
            <span v-if="progetto.ID_PROGETTO == 0 || progetto.URL_AVATAR == 'placeholder.jpg'">
                <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
            </span>
        </div>
        <div class="col-9 col-md-9 mb-2">
            <h4 class="text-primary mb-1" style="height: 3.9rem;">
                {{ progetto.TITOLO }}
            </h4>
            <p class="text-dark mb-1">
                <i class="fal fa-code fa-fw me-1"></i><span class="text-light me-1">|</span>
                Codice: {{ progetto.CODICE_PROGETTO }}
            </p>
            <p class="text-dark mb-1">
                <i class="fal fa-calendar fa-fw me-1"></i><span class="text-light me-1">|</span>
                Evento: {{ filters.formatPeriodo(progetto.DATA_INIZIO_EVENTO, progetto.DATA_FINE_EVENTO) }}
            </p>
            <p class="text-dark mb-1">
                <i class="fal fa-euro-sign fa-fw me-1"></i><span class="text-light me-1">|</span>
                Budget: {{ filters.formattaImporto(progetto.BUDGET_PREVISTO) }}
            </p>
        </div>
    </div>

    <!-- Tab Navigation -->
    <div v-if="progetto && progetto.ID_PROGETTO">
        <div class="row bg-light" style="border-top: 1px solid #ccc;">
            <div class="col-12 ps-0 pe-0">
                <div class="navbar navbar-expand-lg bg-light border-bottom py-1">
                    <div class="container-fluid">
                        <ul class="nav navbar-nav flex-row flex-fill" role="tablist">
                            <li class="nav-item me-1" role="presentation">
                                    <a :href="'#tab-riepilogo-'+rs" ref="tabRiepilogo" class="navbar-nav-link navbar-nav-link-icon active rounded" data-bs-toggle="tab" @click="activeTab = 'riepilogo'" aria-selected="true" role="tab">
                                    <div class="d-flex align-items-center mx-lg-1">
                                        <i class="ph-info"></i>
                                        <span class="d-none d-lg-inline-block ms-1">Riepilogo</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item me-1" role="presentation">
                                    <a :href="'#tab-attivita-'+rs" ref="tabAttivita" class="navbar-nav-link navbar-nav-link-icon rounded" data-bs-toggle="tab" @click="activeTab = 'attivita'" aria-selected="false" tabindex="-1" role="tab">
                                    <div class="d-flex align-items-center mx-lg-1">
                                        <i class="ph-list-checks"></i>
                                        <span class="d-none d-lg-inline-block ms-1">Attività</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item me-1" role="presentation">
                                <a :href="'#tab-team-'+rs" class="navbar-nav-link navbar-nav-link-icon rounded" data-bs-toggle="tab" @click="activeTab = 'team'" aria-selected="false" tabindex="-1" role="tab">
                                    <div class="d-flex align-items-center mx-lg-1">
                                        <i class="ph-users"></i>
                                        <span class="d-none d-lg-inline-block ms-1">Team</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item ms-auto" role="presentation">
                                <div class="dropdown"> 
                                    <a href="#" class="nav-link text-danger rounded d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                                        <div class="d-flex align-items-center mx-lg-1">
                                            <i class="ph-gear me-1"></i> <span class="d-none d-lg-inline-block">Azioni</span>
                                            <i class="ph-caret-down ms-1 small"></i> 
                                        </div>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-end shadow-sm">
                                        <a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('PROGETTO_UPDATE')" v-on:click="modificaProgetto()"><i class="fad fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Progetto </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <!-- Tab Content -->
    <div class="content content-2">
        <div class="tab-content flex-1 order-2 order-lg-1">

            <!-- Tab Riepilogo -->
            <div class="tab-pane fade active show" :id="'tab-riepilogo-'+rs">
                <div class="card">
                    <div class="card-body" style="max-height: calc(100vh - 300px); overflow-y: auto;">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Titolo</label>
                                <p>{{ filters.titoloConTipologia(progetto) }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Codice Progetto</label>
                                <p>{{ progetto.CODICE_PROGETTO }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Cliente</label>
                                <p>{{ progetto.CLIENTE }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Account Manager</label>
                                <p>{{ progetto.ACCOUNT }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Data Evento</label>
                                <p>{{ filters.formatPeriodo(progetto.DATA_INIZIO_EVENTO, progetto.DATA_FINE_EVENTO) }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Data Creazione</label>
                                <p>{{ progetto.DATA_CREAZIONE ? filters.formatDate(progetto.DATA_CREAZIONE) : '-' }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Budget Previsto</label>
                                <p>{{ filters.formattaImporto(progetto.BUDGET_PREVISTO) }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Fee</label>
                                <p>{{ progetto.FEE }}%</p>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label fw-semibold">Descrizione</label>
                                <p>{{ progetto.DESCRIZIONE || 'Nessuna descrizione' }}</p>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label fw-semibold">Note</label>
                                <p>{{ progetto.NOTE || 'Nessuna nota' }}</p>
                            </div>
                            <!-- Stessi totali di Attivita.vue (getTotali), calcolati dal backend, IVA esclusa -->
                            <div class="col-md-12 mb-3" v-if="progetto.TOTALI">
                                <div class="mb-2" style="white-space: nowrap; overflow-x: auto;">
                                    <span class="fw-semibold me-2"><Translate :path="'dizionario.attivita.BUDGET'"></Translate>:</span>
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_PARZIALE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.PARZIALE) }}</span>
                                    <span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.FEE_AGENZIA'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.FEE) }}</span>
                                    <span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.IMPONIBILE) }}</span>
                                    <template v-if="progetto.TOTALI.SCONTO > 0">
                                        <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.SCONTO'"></Translate>: - &euro; {{ filters.formattaImporto(progetto.TOTALI.SCONTO) }}</span>
                                        <span class="badge bg-primary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_GENERALE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.TOTALE) }}</span>
                                    </template>
                                    <span class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.ACQUISTO) }}</span>
                                    <span class="badge bg-warning bg-opacity-20 text-warning rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.COMMISSIONI) }}</span>
                                    <span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.MARGINE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.MARGINE) }}</span>
                                    <span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.UTILE'"></Translate>: {{ progetto.TOTALI.UTILE }}%</span>
                                </div>
                                <div v-if="progetto.TOTALI.CONS_PARZIALE != 0 || progetto.TOTALI.STORNI != 0" style="white-space: nowrap; overflow-x: auto;">
                                    <span class="fw-semibold me-2"><Translate :path="'dizionario.attivita.CONSUNTIVO'"></Translate>:</span>
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_PARZIALE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.CONS_PARZIALE) }}</span>
                                    <span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.FEE_AGENZIA'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.CONS_FEE) }}</span>
                                    <span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.CONS_IMPONIBILE) }}</span>
                                    <template v-if="progetto.TOTALI.STORNI != 0">
                                        <span class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.STORNI'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.STORNI) }}</span>
                                        <span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.CONS_IMPONIBILE_2) }}</span>
                                    </template>
                                    <span class="badge bg-primary rounded-0 p-2 me-2"><Translate :path="'dizionario.attivita.TOTALE_FINALE'"></Translate>: &euro; {{ filters.formattaImporto(progetto.TOTALI.TOTALE_FINALE) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" :id="'tab-team-'+rs">
                <div class="card">
                    <div class="card-body">
                        <ul v-if="progetto.ACCOUNT_USERNAME" class="list-group list-group-flush">
                            <li class="list-group-item d-flex align-items-center gap-3">
                                <img v-if="progetto.ACCOUNT_AVATAR && progetto.ACCOUNT_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS', progetto.ACCOUNT_AVATAR)" :alt="progetto.ACCOUNT_USERNAME" class="rounded-circle" width="40" height="40">
                                <i v-else class="ph-user-circle" style="font-size: 40px;"></i>
                                <span class="fw-semibold">{{ progetto.ACCOUNT_USERNAME }}</span>
                                <span class="badge bg-primary ms-auto">Account Manager</span>
                            </li>
                        </ul>
                        <ul v-if="utentiCondivisi.length > 0" class="list-group list-group-flush">
                            <li v-for="utente in utentiCondivisi" :key="utente.ID_UTENTE" class="list-group-item d-flex align-items-center gap-3">
                                <img v-if="utente.URL_AVATAR && utente.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS', utente.URL_AVATAR)" :alt="utente.USERNAME" class="rounded-circle" width="40" height="40">
                                <i v-else class="ph-user-circle" style="font-size: 40px;"></i>
                                <span class="fw-semibold">{{ utente.USERNAME }}</span>
                            </li>
                        </ul>
                        <div v-else class="text-muted p-2">Nessun utente condiviso</div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" :id="'tab-attivita-'+rs">
                <div class="input-group input-group-sm">
                    <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca Attività..." :tabindex="1" v-model="searchAttivita.TITOLO.VALUE"/>
                    <button class="btn btn-light" type="button" @click="allExpanded = !allExpanded" title="Espandi/Chiudi tutte">
                        <i :class="allExpanded ? 'ph-caret-down' : 'ph-caret-right'"></i>
                    </button>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div v-if="paginatedList.arr && paginatedList.arr.length > 0">
                            <div v-for="attivita in paginatedList.arr"
                                 :key="attivita.ID_ATTIVITA"
                                 class="mb-3">
                                <TabAttvitaSchedaVisualizzazioneProgetto :attivita="attivita" :filters="filters" :force-expanded="allExpanded" @toggle="toggleAttivita" />
                            </div>
                        </div>
                        <div v-else class="text-muted p-2">
                            Nessuna attività disponibile
                        </div>
                    </div>
                </div>
                <Pagine v-model="searchAttivita.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="searchAttivita.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
            </div>

        </div>
    </div>

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import TabAttvitaSchedaVisualizzazioneProgetto from '@/components/utils/TabAttvitaSchedaVisualizzazioneProgetto.vue'

export default {
    name: "SchedaVisualizzazioneProgetto",
    props: ["modulo"],
    components: {
        Pagine,
        TabAttvitaSchedaVisualizzazioneProgetto,
    },
    emits: ['modificaProgetto'],

    data() {
        return {
            filters: global.filters,
            progetto: {},
            rs: utils.generateRandomString(30),
            activeTab: 'riepilogo',
            arrayAttivita: [],
            allExpanded: null,
             
            searchAttivita:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				TITOLO:{TYPE:'TEXT',VALUE:''},
	        },
        }
    },

    methods: {
        openSchedaVisualizzazioneProgetto(progetto) {
            if (!progetto || !progetto.ID_PROGETTO) {
                console.warn('Progetto non valido');
                return;
            }
            utils.get("theb/progetto/dettaglio", { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.progetto = response.data[0];
                    this.$nextTick(() => this.$refs.tabRiepilogo.click());
                    this.getAttivita(progetto.ID_PROGETTO);
                } else {
                    console.warn('Nessun progetto trovato per ID:', progetto.ID_PROGETTO);
                }
            });
        },

        getAttivita(idProgetto) {
            utils.get("theb/attivita/lista", { FK_ID_PROGETTO: idProgetto }, (response) => {
                this.arrayAttivita = (response.data || []).map(attivita => this.prepareAttivita(attivita));
            });
        },

        prepareAttivita(attivita) {
            return {
                ...attivita,
                VOCI: attivita.VOCI || [],
                SOTTO_ATTIVITA: (attivita.SOTTO_ATTIVITA || []).map(sotto => this.prepareAttivita(sotto))
            };
        },

        toggleAttivita(attivita) {
            attivita.expanded = !attivita.expanded;
        },

        modificaProgetto() {
            this.$emit("modificaProgetto", this.progetto);
        }
    },

    computed: {
        utentiCondivisi(){
            return (this.progetto.UTENTI_CONDIVISI || []).filter(u => u.ID_UTENTE != this.progetto.FK_ID_UTENTE);
        },
        paginatedList(){
            var arr = utils.inGrid(this.arrayAttivita,this.searchAttivita);
            return arr;
        },
    }
}
</script>